import React, { memo, useState } from "react";
import { Link } from "react-router-dom";
import { HotelType } from "../../../../backend/src/shared/types";
import { AiFillStar } from "react-icons/ai";
import { useSearchContext } from "../../contexts/SearchContext";
// import { PerNightPrice } from "../HotelPriceComponent";
// import { useSearchContext } from "../../contexts/SearchContext";

type Props = {
  hotel: HotelType;
};

const HotelCard: React.FC<Props> = ({ hotel }) => {
  // const { checkIn, checkOut, adultCount, childCount } = useSearchContext();
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const placeholderImage = '/Continent/sub-preloaded.webp';
  const search = useSearchContext();

      const searchParams = new URLSearchParams({
        checkIn: search.checkIn.toISOString(),
        checkOut: search.checkOut.toISOString(),
        guests: JSON.stringify(search.guests),
        roomCount: search.roomCount.toString(),
        nights: search.nights.toString(),
        vacationType: search.vacationType,
        hotelId: hotel.id,
        regionId: search.regionId,
      }).toString();

  return (
    <Link
      to={
        hotel.type.includes('Flash Deals')
          ? `/last-minute-deals/${hotel.slug}`
          : `/resort/${hotel.id}?${searchParams}`
      }
      target="_blank"
      rel="noopener noreferrer"
      className="cursor-pointer overflow-hidden rounded-md"
    >
      <div className="relative h-[20rem] w-[17rem]">
        {hotel.availability === 'Sold Out' && (
          <div className="absolute top-2 z-10 left-2 bg-red-600 text-white text-xs font-bold py-1 px-2 rounded">
            SOLD OUT
          </div>
        )}

        <img
          src={hotel.imageUrls[0]}
          //loading="lazy"
          className={`w-96 h-full object-cover object-center hover:scale-105 transition duration-500 cursor-pointer ${isImageLoaded ? '' : 'hidden'}`}
          alt="Hotel Image"
          onLoad={() => setIsImageLoaded(true)}
        />
        {!isImageLoaded && (
          <img
            className="h-full w-full object-cover p-24"
            src={placeholderImage}
            alt="Loading placeholder"
          />
        )}
      </div>
      <div className="bottom-0 pt-2 rounded-b-md w-[17rem] mt-2 items-center">
        <div className="flex justify-between items-center">
          <div className="flex">
            {Array.from({ length: hotel.starRating }).map((_, index) => (
              <AiFillStar key={index} className="text-yellow-400" />
            ))}
          </div>
          <div className="text-sm text-gray-500">
            {hotel.tripRating}
            {` (${hotel.tripAdvisorRating}) reviews`}
          </div>
        </div>
        <span className="text-black font-medium tracking-tight text-12 cursor-pointer hover:text-halo-pink line-clamp-1">
          {hotel.name}
        </span>
      </div>
      <div className="bottom-0 rounded-b-md w-[17rem] justify-between flex items-center">
        <span className="text-neutral-600 text-sm tracking-tight cursor-pointer">
          {hotel.city}, {hotel.country}
        </span>
      </div>
      <div className="bottom-0 rounded-b-md w-[17rem] justify-between flex items-center font-medium mt-2">
        <div className="text-halo-pink py-1 text-md font-medium hover:text-pink-800 underline-animation">
          <div className="">View Deal</div>
        </div>
        {/* 
        <div className="text-sm">
          Starting from
          <span className="text-halo-pink text-lg tracking-tight font-medium cursor-pointer ml-2">
          <PerNightPrice hotelName={"a"} 
            checkIn={checkIn.toISOString().split('T')[0]}
            checkOut={checkOut.toISOString().split('T')[0]}
            adultCount={adultCount}
            childCount={childCount} 
            propertyToken={hotel.serpId} />
          </span>
        </div> 
        */}
        {hotel.type.includes('Flash Deals') && (
          <div className="text-sm">
            Starting from
            <span className="text-halo-pink text-lg tracking-tight font-medium cursor-pointer ml-2">
              $ {hotel.pricePerNight}
            </span>
          </div>
        )}
      </div>
    </Link>
  );
};

export default memo(HotelCard);
